module.exports = __webpack_public_path__ + "static/media/dhl-logo.61044047.svg";